<template>
  <div id="review" class="wrap_review">
    <textarea
      ref="chatTextarea"
      class="review-content"
      :placeholder="placeholder"
      maxlength="150"
      v-model="content">
    </textarea>
    <div class="review-bottom">
      <el-popover
        ref="expression"
        placement="bottom-start"
        width="400"
        trigger="click"
        v-model="isShowExpression">
        <YExpression @select="handleSelectExpression" />
      </el-popover>
      <div class="expression"><el-button v-popover:expression class="iconfont icon-bq"></el-button></div>
      <div v-if="isRoomTeacher || isRoomGuest || isManger" class="pic_wrap">
        <el-upload
          class="chat-uploader"
          action=""
          :show-file-list="false"
          :http-request="handleUpload">
          <el-button class="iconfont icon-img"></el-button>
        </el-upload>
      </div>
      <div class="reply">
        <el-tag
          v-show="replyId > 0"
          class="reply-tag"
          type="primary"
          :closable="true"
          @close="handleCancelReply"
      ><span>回复：</span><span class="reply-username ellipsis">{{ replyUserName }}</span></el-tag>
      </div>
      <div class="button">
        <span>剩余<i>{{150 - content.length }}</i>字</span>
        <input type="button" :value="isSending ? '发送中...' : '发送'" @click="handleSubmit" />
      </div>
    </div>
  </div>
</template>

<script>
import escape from 'lodash/escape'
import { mapGetters, mapState } from 'vuex'
import Dialog from '@/utils/Dialog'
import YExpression from '@/components/editor/Expression'

export default {
  name:'component-room-review',
  data () {
    return{
      // textarea初始化值
      content: '',
      placeholder: '尽情的聊起来吧',
      isShowExpression: false,
      isSending: false
    }
  },
  methods: {
    // 上传本地图片按钮
    handleUpload ({ file }) {
      // 验证
      if (!this.$isLogin()) {
        this.$message.error('您还未登陆!')
        return
      }

      if (!file.type.match(/image.*/)) {
        this.$message.error('上传图片只能是 JPG/PNG/GIF 格式!')
        return
      }

      if (!(file.size / 1024 < 600)) {
        this.$message.error('上传图片大小不能超过 600KB!')
        return
      }

      // 上传文件
      this.$axios.postFile('/Common/UploadImage', { type: 4 }, file).then(resp => {
        if (resp && resp.url) {
          this.content = this.content + '[#' + resp.url + '#]'
        }
      })
    },
    // 发表评论
    handleSubmit (e) {
      if (!this.$isLogin()) {
        Dialog.login()
        return false
      }
      if (!this.content) {
        return false
      }
      const params = {
        room_id: this.roomData.id,
        topic_id: this.roomData.lastTopicId,
        content: escape(this.content),
        reply_index: this.replyId,
      }
      this.isSending = e.target.disabled = true
      this.$axios._post('/Room/Comment', params).then(resp => {
        // 清空输入框
        this.content = ''
        this.replyId !== 0 && this.handleCancelReply()
        // 更新comment
        if (!this.$store.state.room.isWebsocket) {
          this.$store.commit('room/addComment', resp)
        }
      }).finally(() => {
        this.isSending = e.target.disabled = false
      })
    },
    // 取消评论
    handleCancelReply () {
      this.$store.commit('room/cancelReply')
      this.placeholder = '尽情的聊起来吧'
    },
    handleSelectExpression (str) {
      this.content += str.ubb
      this.isShowExpression = false
    }
  },
  computed: {
    ...mapGetters({
      isRoomTeacher: 'room/isTeacher',
      isRoomGuest: 'room/isGuest',
      isManger: 'user/isManger'
    }),
    ...mapState({
      roomData: state => state.room.data,
      replyStatus: state => state.room.chat.status,
      replyId: state => state.room.chat.replyId,
      replyUserName: state => state.room.chat.replyUserName,
      isPolling: state => state.room.isPolling
    })
  },
  watch: {
    replyStatus (flag) {
      this.content = ''
      this.$refs.chatTextarea.focus()
      this.placeholder = `回复${this.replyUserName}：`
    }
  },
  components: {
    YExpression
  }
}
</script>

<style lang="less" scoped>
.wrap_review { height: 100%; background: #FFFFFF; position: absolute; top: 0;
  .review-content { resize: none; width: 414px; height: 86px; overflow: hidden; border: none;outline: none; padding-top:10px; padding-left: 12px; padding-right: 12px;  display: block; font-size: 13px;}
  .review-bottom { overflow: hidden;
    .expression,.pic_wrap { float: left;
      button {
        border: none; font-size: 30px; padding: 0 6px;
      }
    }
    .button { width: 164px; float: right; text-align: right; padding-right: 10px;
      i { color: #e43a3d;}
      input { width: 78px; height: 30px; color: #FFFFFF; background: #e43a3d; cursor: pointer; border: none; outline: none; border-radius: 5px; margin-left: 10px;}
      .isdisabled { background: #6B6B6B; }
    }
  }
  .reply { float: left;
    .reply-tag {
      span {
        float: left;
        &.reply-username { max-width: 120px; }
      }
    }
  }

}
</style>
